const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'controller',
        'controller',
    ],

    config: {
        tabConfigNavKey: 'projects',
        showEditByMySelf: true,
    },

    methods: {

        // IDEA: in case of performance issues the applications table controller could be permanent.
        showProjectTermJobApplications(rowID, rowData){
            const {
                isAdvertised = false,
                startTS,
                endTS,
                jobCode = '',
            } = attributes = (rowData || {}).attributes || {}
            if(!isAdvertised){
                return this.hideProjectTermJobApplications(rowID, rowData)
            }

            const timeParts = []
            const headParts = [`#${rowID}`]
            if(jobCode)                 headParts.push(jobCode);
            if(startTS)                 timeParts.push(utils.moment(startTS).format('HH:mm'));
            if(endTS)                   timeParts.push(utils.moment(endTS).format('HH:mm'));
            if(timeParts.length > 0)    headParts.push(timeParts.join(' - '));

            const baseActionKey = 'show_projectTermJobApplications'
            this.performAndStoreAction(
                `${baseActionKey}_inEffect`,
                this.prepareAction(
                    baseActionKey,
                    undefined,
                    {
                        controllerConfig: {
                            usage: 'ignore',
                        },
                        tableConfig: {
                            showHead: true,
                            supportLazyloading: false,
                            headSuffix: `&nbsp;&nbsp;&nbsp;${headParts.join(' | ')}`,
                        },
                        parentEntityForTable: {
                            baseFilters: {
                                projectTermJobID: rowID,
                            },
                            filters: {
                                showAllApplicants: true,
                            }
                        }
                    },
                ),
                true
            )
        },

        hideProjectTermJobApplications(rowID, rowData){
            // NOTE: use if necessary
        },
    },
}